"use strict";
import ApiService from "@/core/services/api.service";

const baseURL = "Dashboard";

export default {
  getProvincesList() {
    return new Promise(resolve => {
      ApiService.get(`${baseURL}/GetProvincesList`).then(({ data }) =>
        resolve(data)
      );
    });
  },
  getChartsList() {
    return new Promise(resolve => {
      ApiService.get(`${baseURL}/GetChartsList`).then(({ data }) => {
        resolve(data);
      });
    });
  },
  getTrackersInfo(payload) {
    return new Promise(resolve => {
      ApiService.post(`${baseURL}/GetTrackersInfo`, payload).result.then(
        ({ data }) => resolve(data)
      );
    });
  },
  getTrackersInfoReport() {
    return new Promise(resolve => {
      ApiService.post(`${baseURL}/GetTrackersInfoReport`).result.then(
        ({ data }) => resolve(data)
      );
    });
  },
  getChartData(payload) {
    return new Promise(resolve => {
      ApiService.post(`${baseURL}/GetChartData`, payload).result.then(
        ({ data }) => resolve(data)
      );
    });
  },
  getHeatMapData(payload) {
    return ApiService.post(`${baseURL}/GetHeatMapData`, payload);
  }
};
